export const TOGGLE_OWN_AUDIO = 'TOGGLE_OWN_AUDIO';
export const TOGGLE_OWN_VIDEO = 'TOGGLE_OWN_VIDEO';
export const TOGGLE_OWN_SCREEN = 'TOGGLE_OWN_SCREEN';
